import type { SpawnPoint } from '../protocol.js';

/**
 * Drop-in points spread over the park. Yaw follows three.js: forward is
 * (sin yaw, 0, cos yaw). Kept separate from the geometry so the server can import it
 * without building the course.
 */
export const COURSE_SPAWNS: readonly SpawnPoint[] = [
  { p: [0, 0, 26], yaw: Math.PI },
  { p: [0, 0, -26], yaw: 0 },
  { p: [-30, 0, 2], yaw: Math.PI / 2 },
  { p: [30, 0, -2], yaw: -Math.PI / 2 },
  { p: [-3, 0, -94], yaw: Math.PI },
  { p: [125, 0, -22], yaw: 0 },
  { p: [-100, 0, -50], yaw: 0 },
  { p: [-115, 0, -98], yaw: Math.PI },
  { p: [118, 0, -104], yaw: Math.PI },
  { p: [-20, 0, 90], yaw: Math.PI / 2 },
  { p: [-102, 0, 52], yaw: Math.PI / 2 },
  { p: [96, 0, 48], yaw: Math.PI / 2 },
];

export const COURSE_HALF_EXTENT = 180;
